<template>
<!--  <div class="sbl-circ-path"></div>-->
  <div class="r-d-loader__container">
    <img src="/images/shared/Robins-And-Day-Loader-Purple.svg" alt="Loading" class="r-d-loader__svg" >
  </div>

</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.r-d-loader {
  &__container {
    display: flex;
    justify-content: center;
  }

  &__svg {
    width: 100%;
    max-width: 150px;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/online-service-booking/components/LoadingSpinner.vue